import React from "react";
import eventImg from "../../../assets/Images/home/event_1.png";

const EventsBanner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
      
      {/* Background Image */}
      <img
        src={eventImg}
        alt="Career"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">
        
        {/* Title */}
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Exhibition
        </h1>

        {/* Description */}
   <p className="text-gray-200 text-sm md:text-base mt-2 mb-6 max-w-7xl leading-relaxed">
  Explore our latest exhibitions showcasing innovation, creativity, and excellence. Discover inspiring work and experience ideas brought to life.
</p>

      </div>
    </section>
  );
};

export default EventsBanner;